import { table } from './_table';
import { UserConfigService } from '@core/services/UserConfigService';

export const messages = {
  namespaced: true,
  modules: {
    table
  },

  actions: {
    setBackendPostback: async ({ rootGetters, dispatch }, form) => {
      const current_user_id = rootGetters['core/auth/current_user_id'];

      await UserConfigService.editItem(current_user_id, form);
      await dispatch('core/auth/syncOnlyUserConfig', {}, { root: true });
    }
  }
};
